module.exports = __webpack_public_path__ + "img/client11.78000916.svg";